export const NETWORK_STATUS = {
  OK: 200,
  BAD_REQUEST: 400,
  NOT_AUTHORIZED: 401,
  TIME_OUT: 408,
};
